import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const getContentBlock = createAsyncThunk(
  'auth/getContentBlock',
  async ({
    contentBlockId,
    languageId,
    functionCallback
  }: GetContentBlockType) => {
    const { data } = await axios.get(
      `/content-block/${contentBlockId}/${languageId}`
    );
    if (functionCallback) {
      functionCallback();
    }
    return data.data.contentBlock as ContentBlock;
  }
);

interface GetContentBlockType {
  contentBlockId: number;
  languageId: number;
  functionCallback?: () => void;
}

type ContentBlock = {
  id: number;
  contentBlockId: number;
  title: string;
  content: string;
  dateCreated: string;
  dateUpdated: string;
};

export interface contentBlockSliceType {
  loading: boolean;
  contentBlock: ContentBlock | null;
}

const initialState = {
  loading: false,
  contentBlock: null
} as contentBlockSliceType;

const contentBlockSlice = createSlice({
  name: 'contentBlock',
  initialState,
  reducers: {
    setContentBlock: (state, { payload }) => {
      state.contentBlock = payload;
    }
  },

  extraReducers: (builder) => {
    builder.addCase(getContentBlock.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getContentBlock.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.contentBlock = payload;
    });
    builder.addCase(getContentBlock.rejected, (state) => {
      state.loading = false;
    });
  }
});

export const { setContentBlock } = contentBlockSlice.actions;

export default contentBlockSlice.reducer;
